// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const raichu: PokeData = {
  "id": 26,
  "name": "raichu",
  "height": 8,
  "weight": 300,
  "base_experience": 218,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "slam",
    "tail-whip",
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "agility",
    "quick-attack",
    "double-team",
    "light-screen",
    "swift",
    "sweet-kiss",
    "charm",
    "spark",
    "encore",
    "iron-tail",
    "fake-out",
    "feint",
    "nasty-plot",
    "discharge",
    "electro-ball",
    "play-nice",
    "nuzzle"
  ],
  "moves": [
    "thunder-punch",
    "growl",
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "sweet-kiss",
    "volt-switch",
    "volt-crash",
    "wild-charge",
    "electric-terrain",
    "zap-cannon",
    "electric-wrath"
  ],
  "evolution_chain": {
    "id": 10,
    "item": null,
    "species": [
      {
        "name": "pichu",
        "order": 25,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pikachu",
        "order": 26,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 172,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "raichu",
        "order": 27,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 25,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 167,
    "ability_power": 136
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
